import Table from '../../app-components/table/Table';
import React from 'react';
import {Text} from '../../app-components';
import {removeData} from '../../AppServices';
import {colors} from '../../theme/colors';
import {h14_AvenirNext, h12_Regular} from '../../theme/fonts';
import {listUri} from '../../Queries';
const {backdropColor70} = colors;

let uri = () => {
  return listUri({model: 'Drugs', id: 'drugLists'});
};

const tableData = {
  lg: {
    columns: [
      {
        width: 50,
      },
      {
        render: (props) => {
          return <Text style={{...h12_Regular}}>{props.index + 1}</Text>;
        },
        header: 'S.No.',
        width: 150,
      },
      {
        type: 'text',
        field: 'name',
        header: 'Name',
      },
    ],

    hoverActions: [
      {
        value: 'Edit',
        textStyle: {
          color: '#9a9a9a',
          fontWeight: 500,
          ...h14_AvenirNext,
        },
        action: ({item}) => {
          return {
            type: 'link',
            link: {
              view: 'edit-drug',
              params: {item},
            },
          };
        },
      },
      {
        value: 'Delete',
        position: 'center',
        textStyle: {
          color: 'rgb(241,79,79, 0.87)',
          fontWeight: 500,
          ...h14_AvenirNext,
        },
        action: {
          type: 'link',
          link: (props) => {
            let {item} = props;
            console.log('items====', props, item);
            return {
              view: 'delete-masterData',
              modal: true,
              params: {
                item,
                label: 'Drug',
                deleteAction: () => removeData({item, model: 'Drugs'}),
                reloadEvent: 'reloadDrug',
              },

              modalProps: {
                autoHide: true,
                height: 250,
                backdropColor: backdropColor70,
              },
            };
          },
        },
      },
    ],
  },
  sm: {
    columns: [
      {
        render: (props) => {
          return <Text style={{...h12_Regular}}>{props.index + 1}</Text>;
        },
        header: 'S.No.',
        width: 50,
      },
      {
        type: 'text',
        field: 'name',
        header: 'Name',
      },
      {
        type: 'moreActions',
        width: 50,
        actions: [
          {
            text: 'Edit',
            textStyle: {
              color: '#9a9a9a',
              fontWeight: 500,
              ...h14_AvenirNext,
            },
            action: ({item}) => {
              return {
                type: 'link',
                link: {
                  view: 'edit-drug',
                  params: {item},
                },
              };
            },
          },
          {
            text: 'Delete',
            textStyle: {
              color: 'rgb(241,79,79, 0.87)',
              fontWeight: 500,
              ...h14_AvenirNext,
            },
            action: {
              type: 'link',
              link: (props) => {
                let {item} = props;
                return {
                  view: 'delete-masterData',
                  modal: true,
                  params: {
                    item,
                    label: 'Drug',
                    deleteAction: () => removeData({item, model: 'Drugs'}),
                    reloadEvent: 'reloadDrug',
                  },

                  modalProps: {
                    autoHide: true,
                    height: 250,
                    backdropColor: backdropColor70,
                  },
                };
              },
            },
          },
        ],
      },
    ],
  },
};

export default Table({
  reloadEvent: 'reloadDrug',
  uri,
  ...tableData,
});
